// Setup › COMPANY › DE subscriptions (design spec 2026-10-19 §4, §9): `/c/{slug}/setup/
// subscriptions`, split out of the General page's tabs. Core feature, managers (the Setup gate).
import { createRoute } from "@tanstack/react-router";
import { SetupSubscriptions } from "../features/settings/setup-subscriptions";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupSubscriptionsRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "subscriptions",
  component: function SetupSubscriptionsPage() {
    const { api } = setupSubscriptionsRoute.useRouteContext();
    return <SetupSubscriptions api={api} company={useCompany()} />;
  },
});
